import { Navigate, useParams, useRoutes } from "react-router-dom";
import AccountRoutes from "./account/routes";

import AdminRoutes from "./admin/routes";
import ArticlePage from "./article";
import BillingRoutes from "./billing/routes";
import ContactPage from "./contact";
import ContactCompletePage from "./contact-complete";
import DataCoverageCommoditiesPage from "./data-coverage/commodities";
import DataCoverageCryptoPage from "./data-coverage/crypto";

import DataCoverageEquitiesPage from "./data-coverage/equities";
import DataCoverageFundsPage from "./data-coverage/funds";
import DataCoverageIndicesPage from "./data-coverage/indices";
import HomePage from "./home";
import LoginPage from "./login";
import LogoutPage from "./logout";

import NotFoundPage from "./not-found";
import ProductPage from "./products";
import SignupPage from "./signup";

export default () =>
  useRoutes([
    { path: "/data-coverage/crypto", element: <DataCoverageCryptoPage/> },
    { path: "/data-coverage/indices", element: <DataCoverageIndicesPage/> },
    { path: "/data-coverage/funds", element: <DataCoverageFundsPage/> },
    { path: "/data-coverage/commodities", element: <DataCoverageCommoditiesPage/> },
    { path: "/data-coverage", element: <DataCoverageEquitiesPage/> },
    { path: "/contact/complete", element: <ContactCompletePage/> },
    { path: "/contact", element: <ContactPage/> },
    { path: "/login", element: <LoginPage/> },
    { path: "/logout", element: <LogoutPage/> },
    { path: "/signup", element: <SignupPage/> },
    { path: "/article/:id", element: <WithParameters component={ArticlePage}/> },
    { path: "/products/:type/:id/:action", element: <WithParameters component={ProductPage}/> },
    { path: "/products/:type/:id", element: <WithParameters component={ProductPage}/> },
    { path: "/products/:type", element: <WithParameters component={ProductPage}/> },
    { path: "/account/*", element: <AccountRoutes/> },
    { path: "/admin/*", element: <AdminRoutes/> },
    { path: "/billing/*", element: <BillingRoutes/> },
    { path: "/not-found", element: <NotFoundPage/> },
    { path: "/terms.html", element: <ArticlePage id="terms"/> },
    { path: "/terms", element: <ArticlePage id="terms"/> },
    { path: "/*", element: <Navigate replace to="/not-found"/> },
    { path: "/", element: <HomePage/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  return <Comp {...parameters} />;
}
